const driveway = `https://res.cloudinary.com/dqnjw6dip/image/fetch/https://res.cloudinary.com/dqnjw6dip/image/upload/v1667854923/KTC-Images/driveway_f7iiuf.jpg`;
const patio = `https://res.cloudinary.com/dqnjw6dip/image/fetch/https://res.cloudinary.com/dqnjw6dip/image/upload/v1667854929/KTC-Images/patio_kotkwl.jpg`;
const sidewalk = `https://res.cloudinary.com/dqnjw6dip/image/fetch/https://res.cloudinary.com/dqnjw6dip/image/upload/v1667854931/KTC-Images/sidewalk_ivbsh1.jpg`;
const slab = `https://res.cloudinary.com/dqnjw6dip/image/fetch/https://res.cloudinary.com/dqnjw6dip/image/upload/v1667854933/KTC-Images/slab_n4vxom.jpg`;
const extension = `https://res.cloudinary.com/dqnjw6dip/image/fetch/https://res.cloudinary.com/dqnjw6dip/image/upload/v1667854924/KTC-Images/driveway-ext_pjwytm.jpg`;
const seawall = `https://res.cloudinary.com/dqnjw6dip/image/fetch/https://res.cloudinary.com/dqnjw6dip/image/upload/v1667854931/KTC-Images/seawall_cyiziq.jpg`;

export const sliderConfig = [
  {
    title: 'Driveways',
    image: driveway,
  },
  {
    title: 'Patios',
    image: patio,
  },
  {
    title: 'Sidewalks',
    image: sidewalk,
  },
  {
    title: 'Slabs',
    image: slab,
  },
  {
    title: 'Driveway Extensions',
    image: extension,
  },
  {
    title: 'Seawalls',
    image: seawall,
  }
];